import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationServiceGet = {
    path: "/template/service",
    method: ERouteHttpVerb.GET
};
export { routeLocationServiceGet };
